import React from "react";
import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";

const processOptions = (options) =>
  options.map(({ id }) => ({
    value: id,
    label: id, // Need to be changed
  }));

function PassengerSelect(props) {
  return (
    <RemoteSelect url="passengers" processOptions={processOptions} {...props} />
  );
}

export default PassengerSelect;
